import { Inject, Pipe, PipeTransform } from '@angular/core';
import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';
import { LocalDate } from '../../../shared/jsr310-localdates/types/local-date.type';
import { PlanPreventionEntity } from '../../../data-domains/document-securite/entities/plan-prevention.entity';

@Pipe({
	name: 'libelleValiditePdp'
})
export class LibelleValiditePdpPipe implements PipeTransform {
	
	nowInMillis: number = new Date().getTime();
	
	constructor(
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService
	) {}
	
	transform(pdp: PlanPreventionEntity): string {
		if (pdp.etat === 6) {
			return 'Annulé';
		}
		if (!pdp.finValidite) {
			return '';
		} else {
			let localDateFinValidite = [pdp.finValidite[0], pdp.finValidite[1], pdp.finValidite[2]] as LocalDate;
			let dateFin = this.conversionService.fromLocalDate(localDateFinValidite);
			if (dateFin) {
				dateFin.setHours(23, 59, 59, 999); // ramener la date de fin à 23h59
				if (pdp.expired = this.nowInMillis > dateFin.getTime()) {
					return 'expiré';
				} else {
					return 'en cours';
				}
			}
			return '';
		}
	}
	
}